import Service from '../service';

export default class UserService extends Service {
  baseApi = '/user';

  async getUsers(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async createUser(data) {
    const url = `${this.baseApi}/user`;
    return await this.postResource(url, data);
  }

  async createManager(data) {
    const url = `${this.baseApi}/manager`;
    return await this.postResource(url, data);
  }

  async createAdmin(data) {
    const url = `${this.baseApi}/admin`;
    return await this.postResource(url, data);
  }
}
